<template>
  <basic-container style="position: relative">
    <avue-crud
      :option="option"
      ref="crud"
      :data="data"
      :page.sync="page"
      :search.sync="search"
      @refresh-change="refreshChange"
      @search-change="searchChange"
      @search-reset="searchReset"
      @on-load="onLoad"
    >
      <!-- <template slot="search">
                  <el-date-picker class="w-100p"  :unlink-panels="true" value-format="yyyy-MM-dd" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>

    </template> -->
      <template slot="name" slot-scope="scope">
        <p :class="scope.row.status == '4' ? 'del' : ''">
          {{ scope.row.name }}
        </p>
      </template>
      <template slot="menuLeft" slot-scope="scope">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="openDislog('add')"
          >新增企业
        </el-button>
        <el-button
          class="mar-l-5"
          icon="el-icon-download"
          :loading="downLoading"
          @click="getMetaCommonListExport"
          size="small"
          >导出</el-button
        >
      </template>
      <template slot-scope="scope" slot="menu">
        <template>
          <el-button
            type="text"
            size="small"
            icon="el-icon-view"
            class="none-border"
            @click="openDislog('detail', scope.row)"
            >查看
          </el-button>
          <el-button
            type="text"
            size="small"
            icon="el-icon-edit"
            class="none-border"
            @click="openDislog('edit', scope.row)"
            >编辑
          </el-button>
        </template>
      </template>
    </avue-crud>
    <el-dialog
      :visible.sync="detailDia"
      :close-on-click-modal="false"
      width="60%"
      class="enterDetail"
      destroy-on-close
      append-to-body
    >
      <div slot="title" class="header-title">
        <span class="fts-16">{{ title }}</span>
      </div>
      <VirtualCompanyEntry
        @close="close"
        :doType="doType"
        :currentRow="currentRow"
      ></VirtualCompanyEntry>
    </el-dialog>
  </basic-container>
</template>
<script>
import {
  getMetaCommonList,
  getMetaCommonListExport,
} from "@/api/busiMode/metaCommon";
import { mapGetters } from "vuex";
import { getDictionary, getUrlAsyn } from "@/api/system/dictbiz";
import bankInfo from "./addEnterprise/bankInfo.vue";

import { delCompany } from "@/api/visitor/visitor";
import VirtualCompanyEntry from "./VirtualCompanyEntry";
import companyChangeList from "./companyChangeList";

import { dataOptions } from "./optionVirtual";

const viewPortHeight =
  window.innerHeight ||
  document.documentElement.clientHeight ||
  document.body.clientHeight;
export default {
  components: { VirtualCompanyEntry, bankInfo },

  data() {
    return {
      data: [],
      loading: false,
      detailDia: false,
      downLoading: false,
      enter_export: "wisdom_park.v_wp_virtual_company_export",
      viewPortHeight:
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight,
      form: {
        name: "",
        uniform_social_credit_code: "",
      },
      page: {
        size: 10,
        current: 1,
        total: 0,
      },
      model: "wisdom_park.wp_virtual_company",
      option: dataOptions,
      currentRow: {},
      title: "",
      enterpriseTypes: [],
      firmSizeList: [],
      companyTechnicalTypes: [],
      params: {},
      doType: "",
      search: {
        industry: "",
        name: "",
        uniform_social_credit_code: "",
      },
    };
  },
  created() {
    this.getDicList();
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.code_add, false),
        viewBtn: this.vaildData(this.permission.code_view, false),
        delBtn: this.vaildData(this.permission.code_delete, false),
        editBtn: this.vaildData(this.permission.code_edit, false),
      };
    },
  },
  methods: {
    getBuildList() {
      let obj = {
        size: 1000,
        current: 1,
      };
      getMetaCommonList("wisdom_park.wp_building", obj).then((res) => {
        const data = res.data.data;
        let dicData = [];
        data.records.forEach((e) => {
          dicData.push({
            label: e.name,
            value: e.id,
          });
        });
        this.option.column[1].dicData = dicData;
        this.$forceUpdate();
      });
    },

    getMetaCommonListExport() {
      this.downLoading = true;
      let obj = this.getSearch();
      let o = {
        current: obj.current,
        size: obj.size,
        wheres: obj.wheres,
      };
      getMetaCommonListExport(this.enter_export, o)
        .then((res) => {
          this.downLoading = false;
          let url = window.URL.createObjectURL(new Blob([res.data]));
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.download = "虚拟注册企业数据" + ".xlsx";
          document.body.appendChild(link);
          link.click();
        })
        .catch((e) => {
          this.downLoading = false;
        });
    },

    getDicList() {
      getDictionary({
        code: "firmSize",
      }).then((res) => {
        this.firmSizeList = (res.data.data || []).map((item) => {
          return {
            name: item["dictValue"],
            value: item["dictKey"],
          };
        });
      });
      getUrlAsyn("ImportTemplate").then((res) => {
        if (res.data.data[0].dictKey) {
          this.downId = res.data.data[0].dictKey;
        }
      });
      getDictionary({
        code: "companyTechnicalType",
      }).then((res) => {
        this.companyTechnicalTypes = (res.data.data || []).map((item) => {
          return {
            name: item["dictValue"],
            value: Number(item["dictKey"]),
          };
        });
      });
      getDictionary({
        code: "enterpriseType",
      }).then((res) => {
        this.enterpriseTypes = (res.data.data || []).map((item) => {
          return {
            name: item["dictValue"],
            value: item["dictKey"],
          };
        });
      });
    },
    openDislog(type, row) {
      this.doType = type;
      this.currentRow = row;
      if (type == "detail") {
        console.log(this.doType);
        this.title = "详情";
      } else if (type == "edit") {
        this.title = "编辑";
      } else if (type == "add") {
        this.title = "新增";
      }
      this.detailDia = true;
    },
    refreshChange() {
      this.onLoad(this.page);
    },
    close() {
      this.detailDia = false;
      this.currentRow = {};
      this.refreshChange();
    },
    getSearch() {
      let wheres = [];
      let params = this.params;
      for (let key in params) {
        if (key == "name" || key == "uniform_social_credit_code") {
          wheres.push({ field: key, op: "LIKE", value: params[key] });
        } else if (key == "create_time") {
          wheres.push({ field: key, value: params[key][0], op: "GE" });
          wheres.push({ field: key, value: params[key][1], op: "LE" });
        } else {
          wheres.push({ field: key, value: params[key] });
        }
      }
      let body = {
        current: 1,
        size: this.page.pageSize,
        wheres: wheres,
        orders: [{ field: "create_time", sort: "DESC" }],
      };
      return body;
    },
    searchChange(params, done) {
      this.params = params;
      let o = this.getSearch(params);
      this.getMetaCommonList(o);
      done();
    },
    searchReset() {
      this.onLoad();
    },
    onLoad() {
      let wheres = [];
      for (let key in this.params) {
        if ("" + this.params[key] && key != "isContract") {
          if (key == "name") {
            wheres.push({ field: key, op: "LIKE", value: this.params[key] });
          } else {
            wheres.push({ field: key, value: this.params[key] });
          }
        }
      }
      this.loading = true;
      let body = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        wheres: wheres,
        orders: [{ field: "create_time", sort: "DESC" }],
      };

      if (this.form.name) {
        body["wheres"].push({
          field: "name",
          op: "LIKE",
          value: this.form.name,
        });
      }
      this.getMetaCommonList(body);
    },

    getMetaCommonList(body) {
      getMetaCommonList(this.model, body).then((res) => {
        const data = res.data.data;
        this.page.total = data.total;
        data.records.forEach((e) => {
          if (e.type) {
            this.enterpriseTypes.forEach((type) => {
              if (e.type == type.value) {
                e.type = type.name;
              }
            });
          }
          if (e.firm_size) {
            this.firmSizeList.forEach((q) => {
              if (e.firm_size == q.value) {
                e.firm_size = q.name;
              }
            });
          }
        });
        this.getBuildList();
        this.data = data.records;
        this.loading = false;
      });
    },

    rowDel(row, index) {
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delCompany({ id: row.id }).then((res) => {
            this.$message({
              type: "success",
              message: "操作成功!",
            });
            this.onLoad(this.page);
          });
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-dialog__body {
  padding-top: 0px;
}
/deep/ .el-dialog__header {
  border-bottom: 1px solid #ebebeb;
  padding-bottom: 15px;
}
.enterDetail /deep/ .el-dialog__body {
  padding: 0px;
}
/deep/ .el-drawer__body {
  padding-top: 0px;
  overflow-x: hidden !important;
}
/deep/ .el-drawer__header {
  border-bottom: 1px solid #ebebeb;
  margin-bottom: 0px;
  padding-bottom: 15px;
}

/deep/.el-table--border td:first-child .cell {
  padding-left: 0px;
}

.del {
  text-decoration: line-through;
  color: #bdc3c7;
  font-style: italic;
}
</style>
